/**
 * Allgemeine Geschäftsbedingungen.
 * Quelle: https://devhive.de/agb.html — bei Änderungen dort
 * bitte hier nachziehen.
 */

import { Link } from 'react-router-dom';

export default function AgbPage() {
  return (
    <div className="max-w-2xl mx-auto space-y-6 pb-8 text-slate-200">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Allgemeine Geschäftsbedingungen</h2>
        <Link to="/" className="text-xs text-slate-400 hover:text-slate-200 underline">
          ← zurück
        </Link>
      </div>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 1 Geltungsbereich</h3>
        <p className="text-sm text-slate-300">
          Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen
          DevHive Network (nachfolgend „Anbieter") und dem Kunden (nachfolgend
          „Kunde") über die Bereitstellung des FraktionsVerwaltungsSystems (FVS).
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 2 Leistungsbeschreibung</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>
            Der Anbieter stellt dem Kunden das FVS als Software-as-a-Service (SaaS) zur
            Verfügung.
          </li>
          <li>
            Der Funktionsumfang richtet sich nach dem jeweils vereinbarten
            Leistungspaket.
          </li>
          <li>
            Der Anbieter bemüht sich um eine Verfügbarkeit von 99 % im Jahresmittel.
            Geplante Wartungsarbeiten sind hiervon ausgenommen.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 3 Nutzungsrechte</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>
            Der Kunde erhält ein einfaches, nicht übertragbares Nutzungsrecht am FVS
            für die Dauer des Vertragsverhältnisses.
          </li>
          <li>
            Das System darf ausschließlich für den vereinbarten Zweck
            (Fraktionsverwaltung im Roleplay-Kontext) genutzt werden.
          </li>
          <li>
            Eine Weitergabe, Unterlizenzierung oder Vervielfältigung des Systems ist
            nicht gestattet.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 4 Pflichten des Kunden</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>Der Kunde ist für die Geheimhaltung seiner Zugangsdaten verantwortlich.</li>
          <li>Der Kunde verpflichtet sich, das System nicht missbräuchlich zu nutzen.</li>
          <li>
            Der Kunde stellt sicher, dass die über das System verarbeiteten Daten keine
            Rechte Dritter verletzen.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 5 Vergütung</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>
            Die Vergütung richtet sich nach der individuellen Vereinbarung zwischen
            Anbieter und Kunde.
          </li>
          <li>
            Alle genannten Preise verstehen sich inklusive der gesetzlichen
            Mehrwertsteuer, sofern nicht anders angegeben.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 6 Haftung</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit.</li>
          <li>
            Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung
            wesentlicher Vertragspflichten.
          </li>
          <li>
            Die Haftung für Datenverlust wird auf den typischen Wiederherstellungsaufwand
            beschränkt, der bei regelmäßiger Datensicherung eingetreten wäre.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 7 Datenschutz</h3>
        <p className="text-sm text-slate-300">
          Der Anbieter verarbeitet personenbezogene Daten des Kunden gemäß der{' '}
          <Link to="/datenschutz" className="text-brand hover:underline">
            Datenschutzerklärung
          </Link>{' '}
          und den geltenden Datenschutzgesetzen.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 8 Vertragslaufzeit und Kündigung</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>Die Vertragslaufzeit richtet sich nach der individuellen Vereinbarung.</li>
          <li>
            Eine ordentliche Kündigung ist mit einer Frist von [X Wochen/Monaten] zum
            Ende der jeweiligen Vertragslaufzeit möglich.
          </li>
          <li>
            Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt
            unberührt.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">§ 9 Schlussbestimmungen</h3>
        <ol className="text-sm text-slate-300 list-decimal list-inside space-y-1">
          <li>Es gilt das Recht der Bundesrepublik Deutschland.</li>
          <li>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt
            die Wirksamkeit der übrigen Bestimmungen unberührt.
          </li>
        </ol>
      </section>

      <p className="text-xs text-slate-500">Stand: Februar 2026</p>
    </div>
  );
}
